var heading = {
  color: 'gray.500',
  fontFamily: 'heading',
  lineHeight: 'shorter',
  fontWeight: 'semibold'
};
var heading$1 = heading;
export { heading$1 as default };